<template>
  <div class="page-container">
    <div class="form-signin mt-5">
      <div class="sec-information">
        <div class="inner-sec-information">
          <h2 class="text-center"><span>サービス終了のお知らせ</span></h2>
          <p class="text-center d-block p-4 bg-white mt-5">2025年9月30日（火）をもちまして、ZENGOはサービスを終了いたしました。<br class="br-pc">
              長らくご愛顧いただき、誠にありがとうございました。<br><br>
              類似サービスといたしまして、当社の『蔵衛門』というサービスがございます。
              図面の管理やユーザ同士のトーク機能など、業務をDXするための様々な機能をご用意しております。<br>
              ご興味がございましたら、以下公式サイトよりお問い合せ下さいませ。<br>
              https://www.kuraemon.com/
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {API_LOGIN} from '@/configs/api.js'
import ModalConflictLogin from './ModalConflictLogin.vue'
export default {
  name: 'Login',
  data () {
    return {
      credentials: {
        mail: '',
        password: '',
      },
      errors: {},
      isErrorLogin: false,
      isCallingApi: false,
    };
  },
  components: {
    ModalConflictLogin,
  },
  methods: {
    async onClickLogin (forceLogin = false) {
      let result = await this.$refs.formLogin.validate()
      if (result) {
        this.isErrorLogin = false;
        if (this.isCallingApi) {
          return;
        }
        this.isCallingApi = true;
        try {
          if (forceLogin) {
            this.credentials.force_login = true
          }
          let resLogin = await this.$api.post(API_LOGIN, this.credentials);
          this.isCallingApi = false;
          if (resLogin.data.code === 200) {
            const userInfo = resLogin.data.user_info;
            this.$store.commit('SET_USER_INFO', userInfo);
            if (userInfo.account_level === this.$constant.ADMIN_LEVEL) {
              this.$router.push({name: 'ManagerConstruction'});
            } else if (userInfo.account_level === this.$constant.SUPERVISOR_LEVEL) {
              this.$router.push({name: 'ListConstruction', params: {manager_user_id: userInfo.user_id}});
            } else {
              this.$router.push({name: 'ProjectList'});
            }
          } else {
            if (resLogin.data.code === 406) {
              this.$refs.modalConflictLogin.openModal();
            }
            this.isCallingApi = false;
            this.isErrorLogin = true;
          }
        } catch (error) {
          this.isCallingApi = false;
          console.error(error);
        }
      } else {
        this.isErrorLogin = true;
      }
    }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Login.vue